import AvatarSimpleView from './AvatarSimpleView'

export default AvatarSimpleView
